export const STATUS_QUESTAO = {

    QUESTAO_STATUS_EM_BRANCO : "B",
    QUESTAO_STATUS_RESPONDIDA : "R",
    QUESTAO_STATUS_DUVIDA : "D",
    QUESTAO_STATUS_CORRETA : "C",
    QUESTAO_STATUS_ERRADA : "E"
}

export const IDIOMA_ID = {

    INGLES : "1",
    ESPANHOL : "2"
}

export const TIPO_SIMULADO = {

    DIAGNOSTICO : 1,
    DESENVOLVIMENTO : 2,
    EVOLUCAO : 3
}

export const STATUS_SIMULADO = {

    CANCELADO : 0,
    AGENDADO : 1,
    EM_REALIZACAO : 2,
    REALIZADO : 3,
    CORRIGIDO : 4,
    ANULADO : 5
}

export const INDICADOR_TIPOSIMULADO = {

    REALIZACOES : 1,
    AGENDAMENTOS : 2
}

export const INDICADOR_SERIE = {

    REALIZACOES : 1,
    AGENDAMENTOS : 2
}

export const INDICADOR_ESCOLA = {

    REALIZACOES_SERIE : 1,
    REALIZACOES_TIPOSIMULADO : 2,
    AGENDAMENTOS_SERIE : 3,
    AGENDAMENTOS_TIPOSIMULADO : 4
}

export const AREA_CONHECIMENTO = {

    HUMANAS : 1,
    NATUREZA : 2,
    LINGUAGENS : 3,
    MATEMATICA : 4
}

export const STAGE_TYPE = {

    CONTEUDO : 1,
    RESUMO : 2,
    QUESTOES : 3,
    AVALIAR_CONTEUDO : 4
}

export const STUDY_STATUS = {

    A_REALIZAR : 1,
    REALIZADO : 2,
    CORRIGIDO : 3,
    ANULADO : 4,
    EM_REALIZACAO : 5
}

export const STUDENT_STAGE_STATUS = {

    A_REALIZAR : "A",
    BRANCO : "B",
    CORRIGIDO : "C",
    EM_REALIZACAO : "E",
    REALIZADO : "R"
}

export const TIPO_ACOMPANHAMENTO = {

    GRAFICO: 1,
    LISTA_ALUNOS:2,
    LISTA_ATIVIDADES:3
}
